
<template>
  <!--订单管理-->
  <div>
    <x-tabula
      ref="table"
      :apiOrigin="apiOrigin"
      :excludeResetKey="['order_status']"
      :dataSource="dataSource"
      rowKey="order_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-tooltip>
          <span slot="title">{{row.order_id}}</span>
          <span>{{`${row.order_id.slice(0, 10)}...`}}</span>
        </a-tooltip>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <a-tooltip>
          <span slot="title">{{row.title}}</span>
          <span :style="{whiteSpace: 'nowrap'}">{{typeof row.title === 'string' ? `${row.title.slice(0, 10)}...` : row.title}}</span>
        </a-tooltip>
      </template>
    </x-tabula>

    <!--退款的弹窗-->
    <a-modal
      title="退款确认"
      :visible="drawbackVisible"
      @ok="handleDrawback"
      @cancel="drawbackVisible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      :width="600"
    >
        <a-form :form="form">
          <a-form-item :style="{marginBottom: '10px'}" label=" " :colon="false" v-bind="$store.state.modal_ItemLayout">
            <span class="danger">确认给此订单退款吗？</span>
          </a-form-item>
          <a-form-item label="退款金额" v-bind="$store.state.modal_ItemLayout">
                <a-input v-decorator="['real_refund_fee', relRefund]" placeholder="请输入退款金额"/>
            </a-form-item>

          <a-form-item label="退款原因" v-bind="$store.state.modal_ItemLayout">
            <a-input v-decorator="['refund_content', refundContent]" placeholder="请输入退款原因"/>
          </a-form-item>

        </a-form>
    </a-modal>

  </div>
</template>

<script>
let screenTypeSelect = [
  { label: '横屏首页轮播', value: 1 },
  { label: '竖屏首页轮播', value: 2 }
];
let publishStatusSelect = [
  { label: '未上刊', value: 0 },
  { label: '已上刊', value: 1 },
  { label: '已结束', value: 2 },
  { label: '未上刊已结束', value: 3 }
];
let closeTypeSelect = [
  { label: '超时未支付', value: 1 },
  { label: '用户取消订单', value: 2 }
];
let drawbackTypeSelect = [
  { label: '人工退款', value: 2 },
  { label: '审核未通过', value: 1 }
];
let drawbackStatusSelect = [
  { label: '退款成功', value: 1 },
  { label: '退款失败', value: 2 }
];
export default {
  name: 'orderManage',
  props: {
    activeKey: {
      default: () => 'nonpay'
    }
  },
  data () {
    return {
      apiOrigin: 'PHP',
      orderId: '',
      drawbackVisible: false,
      btnLoading: {loading: false},
      relRefund: {
        rules: [
          {required: true, message: '请输入退款金额'},
          {pattern: /^\d+(\.\d{0,2})?$/, message: '退款金额为两位小数'}
        ]
      },
      refundContent: {
        rules: [
          {required: true, message: '请输入退款原因'},
          {min: 1, max: 20, message: '退款原因20字以内'}
        ]
      },

      /** table 参数 */
      searchList: [],
      searchParams: {
        keywords: undefined,
        screen_type: undefined,
        publish_status: undefined,
        close_type: undefined,
        refund_type: undefined,
        refund_status: undefined,
        create_time: undefined,
        order_status: undefined
      },
      searchArr: [
        { props: ['keywords'], placeholder: '订单号、标题、手机号', options: [], inputType: 'input' },
        { props: ['screen_type'], placeholder: '展位', options: screenTypeSelect, inputType: 'select' },
        { props: ['publish_status'], placeholder: '上刊状态', options: publishStatusSelect, inputType: 'select' },
        { props: ['close_type'], placeholder: '关闭类型', options: closeTypeSelect, inputType: 'select' },
        { props: ['refund_type'], placeholder: '退款类型', options: drawbackTypeSelect, inputType: 'select' },
        { props: ['refund_status'], placeholder: '退款状态', options: drawbackStatusSelect, inputType: 'select' },
        { props: ['create_time'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [],
      rowOpts: [
        { text: '退款', handle: record => this.openDrawback(record), permi: ['community:orderManage:drawback'], key: 'drawback' },
        { text: '详情', handle: record => this.toDetail(record, 'detail'), permi: ['community:orderManage:detail'], key: 'detail' },
        {
          text: '审核',
          handle: record => this.toDetail(record),
          rowOptDisHandle: row => row.order_status !== 2,
          permi: ['community:orderManage:examine'],
          key: 'examine'
        },
        {
          text: '上刊',
          handle: record => this.handlePublish(record),
          rowOptDisHandle: row => row.publish_status !== 0,
          permi: ['community:orderManage:publish'],
          key: 'publish'
        },
        {
          text: '重新退款',
          handle: record => this.reDrawback(record),
          rowOptDisHandle: row => row.refund_status === 1,
          permi: ['community:orderManage:reDrawback'],
          key: 'reDrawback'
        }
      ],
      columns: [],
      rows: [
        { title: '订单号', dataIndex: 'order_id', align: 'left', width: '140px', scopedSlots: {customRender: 'o'} },
        { title: '订单标题', dataIndex: 'title', align: 'left', width: '140px', scopedSlots: {customRender: 't'} },
        { title: '订单金额(￥)', dataIndex: 'real_total_fee', align: 'left', width: '120px' },
        { title: '退款金额(￥)', dataIndex: 'real_refund_fee', align: 'left', width: '130px' },
        { title: '手机号', dataIndex: 'mobile_phone', align: 'left', width: '130px' },
        { title: '展位', dataIndex: 'screen_type_desc', align: 'left', width: '120px' },
        { title: '下单时间', dataIndex: 'create_time', align: 'left', width: '200px' },
        { title: '关闭时间', dataIndex: 'close_time', align: 'left', width: '' },
        { title: '类型', dataIndex: 'close_type_desc', align: 'left', width: '120px' },
        { title: '投放时间', dataIndex: 'publishTime', align: 'left', width: '140px' },
        { title: '上刊状态', dataIndex: 'publish_status_desc', align: 'left', width: '100px' },
        { title: '退款类型', dataIndex: 'refund_type_desc', align: 'left', width: '120px' },
        { title: '退款状态', dataIndex: 'refundStatus', align: 'left', width: '110px' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '160px', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '',
        resHandle: this.resHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {},
      deleteParam: {}
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.handleTab();
  },
  methods: {
    handleTab () {
      if (this.activeKey === 'service') {
        this.listApi.url = '/screen_show/refund';
      } else {
        this.listApi.url = '/screen_show/order';
      }

      // 订单状态(1待支付；2待审核；3审核通过；4审核不通过(退全款)；5关闭；6部分退款)
      let orderType = {
        nonpay: 1,
        nonAudit: 2,
        pass: 3,
        closed: 5
      };
      this.searchParams.order_status = orderType[this.activeKey];

      this.handleData('search', 'props', this.searchArr, this.searchList);
      this.handleData('rowOpt', 'key', this.rowOpts, this.rowOptList);
      this.handleData('column', 'dataIndex', this.rows, this.columns);
    },
    /** 处理不同的list */
    handleData (type, key, source, target) {
      let tabObj = {
        nonpay: {
          search: ['keywords', 'screen_type', 'create_time'],
          rowOpt: ['detail'],
          column: ['order_id', 'title', 'real_total_fee', 'mobile_phone', 'screen_type_desc', 'create_time', 'publishTime', 'action']
        },
        nonAudit: {
          search: ['keywords', 'screen_type', 'create_time'],
          rowOpt: ['detail', 'examine'],
          column: ['order_id', 'title', 'real_total_fee', 'mobile_phone', 'screen_type_desc', 'create_time', 'publishTime', 'action']
        },
        pass: {
          search: ['keywords', 'screen_type', 'publish_status', 'create_time'],
          rowOpt: ['drawback', 'detail', 'publish'],
          column: ['order_id', 'title', 'real_total_fee', 'mobile_phone', 'screen_type_desc', 'create_time', 'publishTime', 'publish_status_desc', 'action']
        },
        closed: {
          search: ['keywords', 'screen_type', 'close_type', 'create_time'],
          rowOpt: ['detail'],
          column: ['order_id', 'title', 'real_total_fee', 'mobile_phone', 'screen_type_desc', 'create_time', 'close_time', 'close_type_desc', 'action']
        },
        service: {
          search: ['keywords', 'screen_type', 'refund_type', 'refund_status', 'create_time'],
          rowOpt: ['detail', 'reDrawback'],
          column: ['order_id', 'title', 'real_total_fee', 'real_refund_fee', 'mobile_phone', 'screen_type_desc', 'create_time', 'publishTime', 'refund_type_desc', 'refundStatus', 'action']
        }
      };
      let indexArr = tabObj[this.activeKey][type];
      source.forEach((el) => {
        let compareKey = typeof el[key] === 'string' ? el[key] : el[key][0];
        if (indexArr.includes(compareKey)) {
          target.push({...el});
        }
      });
    },
    /** 上刊 */
    handlePublish (row) {
      this.$confirm({
        title: '请确认此订单的物料已经在所选的位置成功投放再点确定。确定后，用户将在订单详情中看到自己的订单已经上刊。',
        centered: true,
        onOk: (close) => {
          this._put({
            url: `/screen_show/publish/${row.order_id}`,
            params: {}
          }).then(({data}) => {
            close();
            this.$message.success('上刊成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    /** 打开退款弹窗 */
    openDrawback (row) {
      this.orderId = row.order_id;
      this.drawbackVisible = true;
    },
    /** 重新退款 */
    reDrawback (row) {
      this.$confirm({
        title: '你确定要重新退款？',
        centered: true,
        onOk: (close) => {
          this._put({
            url: `/screen_show/restart_refund/${row.order_id}`,
            params: {}
          }).then(({data}) => {
            close();
            this.$refs.table.getTableList();
          });
        }
      });
    },
    /** 手动发起退款 */
    handleDrawback () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this._post({
          url: `/screen_show/start_refund/${this.orderId}`,
          params: values
        }).then(({data}) => {
          this.drawbackVisible = false;
          this.$message.success('退款成功');
          this.$refs.table.getTableList();
        });
      });
    },
    /** 进入详情或审核订单 */
    toDetail (row, detail) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.order_id,
          type: this.activeKey,
          status: !detail ? `${row.order_status}` : '',
          title: !detail ? '订单审核' : '订单详情',
          ...this.breadParam(this)
        }
      });
    },
    resHandle (res) {
      res.forEach((el) => {
        el.publishTime = `${el.start_time}-${el.expire_time}`;
        el.refundStatus = el.refund_status === 2
          ? `${el.refund_status_desc}(${el.refund_fail_content})`
          : el.refund_status_desc;
      });
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss">
  @import "../../style/variable";
  .order-txt {
    @include over-txt(150px);
  }
</style>
